export function getSubArray(data, primaryIndex, secondaryIndex) {
    return data && data[primaryIndex] && data[primaryIndex][secondaryIndex] || [];
}
export function getArray(data, primaryIndex) {
    return data[primaryIndex] || [];
}
//# sourceMappingURL=getArray.js.map